<template>
    <div>
        <div class="input-group input-group-sm">
            <b-input-group>
                <b-input-group-prepend is-text>
                    <i class="fas fa-user"></i>
                </b-input-group-prepend>
                <b-form-input data-hj-whitelist id="contact" v-model="contactText" readonly></b-form-input>
                <b-input-group-append>
                    <b-button variant="outline-primary" v-b-modal="'form-view-contact'" :disabled="organisation==null" v-tooltip="organisation==null ? 'Selecteer eerst een organisatie': null" v-shortkey="{openAfasContactModel: ['p']}" @shortkey="keyDown" :hidden="hideSelect">Selecteer</b-button>
                </b-input-group-append>
            </b-input-group>
        </div>
        <b-modal
                @shown="show"
                @hidden="$root.modelOpen = false"
                :no-close-on-backdrop="true"
                :lazy="true"
                :ref="'form-view-contact'"
                :id="'form-view-contact'"
                title="Contactpersoon selecteren"
                size="xl"
                scrollable>
            <div>
                <div class="input-group">
                    <input data-hj-whitelist class="form-control" type="search" ref="contactSearchField" v-model="q" placeholder="E-mailadres, Naam e.d." aria-label="Search" @keyup.enter="search(q)">
                    <div class="input-group-append">
                        <button class="btn btn-outline-primary" @click="search(q)" type="submit">Zoeken</button>
                    </div>
                </div>

                <div class="detail-list mt-2">
                    <div class="d-flex mt-3 mb-3 justify-content-between">
                        <div class="text-muted m-auto justify-content-center">
                            <small v-if="loaded!==null">
                                <a class="refresh force" @click="refresh()"><em class="fa fa-sync"></em> <timeago :since="loaded":auto-update="30"></timeago> bijgewerkt</a>
                            </small>
                            <small v-if="loaded===null">
                                <em class="fa fa-sync fa-spin"></em> Bezig met ophalen van resultaten
                            </small>
                        </div>
                    </div>

                    <strong>Resultaten:</strong>

                    <div class="result-header" v-if="results.length >0">
                        <div class="list-group list-group-flush mr-3">
                            <div class="list-group-item">
                                <div class="text-sm-left d-flex justify-content-between align-items-center">
                                    <div style="flex-grow: 2; flex-basis:0;"><strong>T</strong></div>
                                    <div style="flex-grow: 10; flex-basis:0;"><strong>Naam</strong></div>
                                    <div style="flex-grow: 10; flex-basis:0;"><strong>Plaats</strong></div>
                                    <div style="flex-grow: 10; flex-basis:0;"><strong>E-mailadres</strong></div>
                                    <div style="flex-grow: 5; flex-basis:0;"><strong>Telefoonnummer</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="results">
                        <div class="pt-5 pb-5 text-center" v-if="results.length === 0 && loaded !== null">
                            <i class="fas fa-user-times fa-4x text-muted m-4"></i>
                            <p>Geen contactpersonen gevonden, <a @click="openCreateModal()" class="force">er een toevoegen?</a></p>

                        </div>
                        <div class="list-group list-group-flush">
                            <a @click="select(result)" v-for="result in results" class="list-group-item">
                                <div class="d-flex justify-content-between align-items-center text-sm-left">
                                    <div style="flex-grow: 2; flex-basis:0;"><strong>{{result.type}}</strong></div>
                                    <div style="flex-grow: 10; flex-basis:0;">{{result.name ? result.name : '-'}}</div>
                                    <div style="flex-grow: 10; flex-basis:0;">{{result.city ? result.city : '-'}}</div>
                                    <div style="flex-grow: 10; flex-basis:0;">{{result.email ? result.email : '-'}}</div>
                                    <div style="flex-grow: 5; flex-basis:0;">{{result.tel ? result.tel : '-'}}</div>
                                    <div>
                                        <i class="fas fa-chevron-right"></i>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
            <div slot="modal-footer" class="w-100">
                <button class="btn btn-outline btn-outline-primary" @click="openCreateModal()">
                    <i class="fas fa-plus-circle"></i> Nieuwe contactpersoon toevoegen
                </button>
                <button class="btn btn-light float-right" @click="hide">
                    Sluiten
                </button>
            </div>
        </b-modal>

        <afas-contact-create ref="create-form" :organisation="organisation" :form="form" @finished="select"></afas-contact-create>
    </div>
</template>

<script>
    import afasContactCreate from './afasContactCreate';

    export default {
        components: {
            afasContactCreate
        },
        data() {
            return {
                results: [],

                loaded: null,

                errors: [],

                q: '',
            }
        },
        props: {
            value: [Object, null],
            organisation: [Object, null],
            form: {
                type: Object,
                required: true,
            },
            hideSelect : {
                type: Boolean,
                default: false
            }
        },
        watch: {
            organisation(n, o) {
                if(!this.value || (this.organisation !== undefined && !this.value.afas_id.startsWith(this.organisation.afas_id))) {
                    this.$emit('input', null);
                }
                this.search(this.q);
            }
        },
        mounted() {
            this.search(this.q);
        },
        computed: {
            contactText() {
                if(!this.value) {
                    return '';
                }

                return [this.value.name, this.value.email, this.value.tel].join('; ');
            }
        },
        methods: {
            hide() {
                this.q = '';
                this.$refs['form-view-contact'].hide();
            },
            show(model) {
                this.$root.modelOpen = model.target.id;
                this.$refs.contactSearchField.focus();
            },
            search(q) {
                if(!this.organisation) {
                    return;
                }
                this.showing = null;
                this.loaded = null;
                this.errors = [];

                axios.post('/api/v1/leads/afas/contact/find', {
                        q: q,
                    organisation_id: this.organisation.afas_id,
                    })
                    .then(response => {
                        this.loaded = new Date();
                        this.results = response.data;
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
            refresh() {
                this.search(this.q);
            },
            select(result) {
                if (result && result.is_valid && result.is_valid === true) {
                    this.$emit('input', result);
                    this.hide();
                    return;
                }

                // When the contact data is not valid, open the modal with form.
                this.$refs['create-form'].show(result);
            },
            openCreateModal() {
                this.$refs['create-form'].show();
            },
            keyDown(event) {
                switch (event.srcKey) {
                    case 'openAfasContactModel':
                        if(this.organisation) {
                            this.$refs['form-view-contact'].show();
                        }
                    break;
                }
            }
        }
    }
</script>